import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from '@mui/material';
import { Article, ArticleTypes } from '../../api/blogs';
import { KENNISBANK_ARTICLE_ITEM_ROUTE } from '../../pages/routes';
import React from 'react';
import AppLink from '../Link/AppLink';
import NextLink from 'next/link';
import { AcnCloudIcon } from '../Content/icons/AcnCloudIcon';
import { CommuniqateIcon } from '../Content/icons/CommuniqateIcon';
import { MarqtingIcon } from '../Content/icons/MarqtingIcon';

interface ArticleCardProps {
  article: Article;
}

export function ArticleCard(props: ArticleCardProps) {
  const { article } = props;
  const articleLink = KENNISBANK_ARTICLE_ITEM_ROUTE + article.path;

  return (
    <NextLink passHref as={articleLink} href={articleLink}>
      <Card
        sx={{
          '&:hover': {
            cursor: 'pointer',
            opacity: 0.8,
          },
        }}
      >
        <CardHeader
          sx={{ '.MuiCardHeader-action': { mt: 0.5, mr: 0 } }}
          title={article.metadata.title}
          action={<AppLogo article={article} />}
        />
        <CardMedia
          component="img"
          height="200"
          image={article.metadata.image}
          alt={article.metadata.title}
        />
        <CardContent sx={{ minHeight: 150 }}>
          <Typography>{article.metadata.short_description}</Typography>
        </CardContent>
        <CardActions sx={{ p: 2 }}>
          <Button
            fullWidth
            variant={'contained'}
            component={AppLink}
            href={articleLink}
          >
            Artikel lezen
          </Button>
        </CardActions>
      </Card>
    </NextLink>
  );
}

function AppLogo(props: ArticleCardProps) {
  const { article } = props;
  const app = article.metadata.type;

  switch (app) {
    case ArticleTypes.COMMUNIQATE:
      return <CommuniqateIcon />;
    case ArticleTypes.MARQTING:
      return <MarqtingIcon />;
    case ArticleTypes.ALGEMEEN:
    default:
      return <AcnCloudIcon />;
  }
}
